module.exports = __webpack_public_path__ + "resources/img/sp_support.dc520edc76b311beacb3885834e6d535.png";